import {
  accountsEnvironment,
  authwsEnvironment,
  dataAccessEnvironment,
  fleetEnvironment,
  routingProfileServiceEnvironment,
} from 'data-access';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

export function configureDataAccessEnvironment() {
  accountsEnvironment.baseUrl = environment.daAccountsEnvBaseUrl;
  authwsEnvironment.baseUrl = environment.daAuthwsEnvBaseUrl;
  fleetEnvironment.baseUrl = environment.daFleetEnvBaseUrl;
  routingProfileServiceEnvironment.baseUrl = environment.routingProfileUrl;

  dataAccessEnvironment.configuration.showZodErrorsInConsole =
    location.href.startsWith('http://localhost:4200');

  return () => of();
}
